module.exports = __webpack_public_path__ + "img/tomoshibi-logo.bcae98aa.svg";